import React from "react";
import "./CTASection.css";

const CTASection = () => {
  return (
    <section className="cta-section">
      <div className="container">
        <div className="cta-content">
          <div className="cta-background">
            <div className="cta-blob cta-blob-1"></div>
            <div className="cta-blob cta-blob-2"></div>
            <div className="cta-blob cta-blob-3"></div>
          </div>
          
          <div className="cta-text">
            <h2 className="cta-title">
              Prêt à révolutionner votre prise de rendez-vous ?
            </h2>
            <p className="cta-subtitle">
              Rejoignez plus de 500 entreprises qui ont déjà automatisé leur planning 
              et économisent 3h par jour grâce à Monagora.
            </p>
            
            <div className="cta-features">
              <div className="cta-feature">
                <span>Mise en place en 15 minutes</span>
              </div>
              <div className="cta-feature">
                <span>Satisfait ou remboursé 30 jours</span>
              </div>
              <div className="cta-feature">
                <span>Support français inclus</span>
              </div>
            </div>
          </div>
          
          <div className="cta-actions">
            <div className="cta-buttons">
              <button className="cta-btn primary">
                <span>Commencer gratuitement</span>
                <span className="btn-icon">→</span>
              </button>
              <button className="cta-btn secondary">
                <span>Voir une démonstration</span>
                <span className="btn-icon">▶</span>
              </button>
            </div>
            
            <div className="cta-guarantee">
              <div className="guarantee-badge">
                <div className="guarantee-text">
                  <strong>Essai gratuit de 14 jours</strong>
                  <p>Aucune carte bancaire requise</p>
                </div>
              </div>
            </div>
            
            <div className="cta-urgency">
              <div className="urgency-content">
                <div className="urgency-text">
                  <strong>Offre limitée :</strong> 2 mois offerts pour toute inscription avant le 31 janvier
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="cta-social-proof">
          <p className="social-proof-text">Ils nous font confiance :</p>
          <div className="testimonials-mini">
            <div className="testimonial-item">
              <div className="testimonial-stars">⭐⭐⭐⭐⭐</div>
              <p>"Incroyable ! On a économisé 40% de notre temps admin"</p>
              <cite>- Marie, Plomberie Dubois</cite>
            </div>
            <div className="testimonial-item">
              <div className="testimonial-stars">⭐⭐⭐⭐⭐</div>
              <p>"Plus aucun conflit de planning depuis qu'on utilise Monagora"</p>
              <cite>- Jean, Électricité Pro</cite>
            </div>
            <div className="testimonial-item">
              <div className="testimonial-stars">⭐⭐⭐⭐⭐</div>
              <p>"Nos clients adorent la facilité de prise de RDV"</p>
              <cite>- Sophie, Clim Services</cite>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection; 